var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefinedgeLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 122.95,
    y1: 114.27,
    x2: 61.5,
    y2: 72.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#f3ded5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ecb5a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e06043"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Definedge logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.1,
    width: 119,
    height: 117.79,
    rx: 14.19,
    fill: "#d84728"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.37,38.54V22.07A12.63,12.63,0,0,0,97.75,9.45H22.25A12.63,12.63,0,0,0,9.63,22.07V97.93a12.47,12.47,0,0,0,1.6,6.13C46.24,58.5,84.08,43.22,110.37,38.54Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25,110.55h75.5a12.63,12.63,0,0,0,12.62-12.62V38.54c-26.29,4.68-64.13,20-99.14,65.52A12.61,12.61,0,0,0,22.25,110.55Z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25,112.12h75.5a14.19,14.19,0,0,0,14.19-14.19V22.07A14.19,14.19,0,0,0,97.75,7.88H22.25A14.19,14.19,0,0,0,8.06,22.07V97.93a14.23,14.23,0,0,0,14.19,14.19ZM9.63,97.93V22.07A12.63,12.63,0,0,1,22.25,9.45h75.5a12.63,12.63,0,0,1,12.62,12.62V97.93a12.63,12.63,0,0,1-12.62,12.62H22.25a12.61,12.61,0,0,1-11-6.49A12.47,12.47,0,0,1,9.63,97.93Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.63,75.49C34.16,60.72,36.34,53,37.94,49H26.19c-.2,9.24,0,33.14,6.75,47.59A104.37,104.37,0,0,1,32.63,75.49Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.68,38.4,37,37l6.49-.88a10.79,10.79,0,0,0,.21-2.14,10.55,10.55,0,1,0-1,4.46Zm-6.4-8.61a1.78,1.78,0,1,1-1.77,1.77A1.78,1.78,0,0,1,36.28,29.79Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.65,32.51c-6.33-10.28-29.8-8.94-47.86-8.06A15.81,15.81,0,0,1,49,33.94a16.18,16.18,0,0,1-.32,3.21,16.44,16.44,0,0,1-1.16,3.49c-.1.2-.2.4-.31.59C60.58,37.79,82,35.08,85.5,48.56c5,19.27-29.76,40.17-51.57,48.06,11.13-2.52,33.5-8.84,47.23-21.3C100,58.22,100.06,42.93,93.65,32.51Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefinedgeLogoMobile);
export default __webpack_public_path__ + "static/media/definedge_logo_mobile.2e40539e2a14d73bc9b90a3f68aef369.svg";
export { ForwardRef as ReactComponent };